var o=Object.defineProperty;var a=(e,r)=>{for(var n in r)o(e,n,{get:r[n],enumerable:!0})};function i(e){return new DOMParser().parseFromString(e,"text/html")}function s(e){let r=new XMLSerializer,n=[];for(let t of e.body.children)n.push(r.serializeToString(t));return`${n.join(`
`)}
`}export{a,i as b,s as c};
/*! For license information please see chunk-X37JABN5.mjs.LEGAL.txt */
//# sourceMappingURL=chunk-X37JABN5.mjs.map